var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFinancialManage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.91 4.41v-.532C14.91 2.289 13.71 1 12.237 1h-8.54c-1.48 0-2.683 1.29-2.683 2.878v9.22c0 1.585 1.128 2.877 2.515 2.877h9.93c1.388 0 2.519-1.289 2.519-2.877V6.755A3.013 3.013 0 0014.91 4.41zm0 8.688c0 .95-.65 1.726-1.439 1.726H3.53c-.797 0-1.439-.774-1.439-1.726v-9.22A1.675 1.675 0 013.696 2.15h8.54a1.669 1.669 0 011.604 1.727v.046a2.043 2.043 0 00-.377-.046H4.755a.555.555 0 00-.535.575.555.555 0 00.535.576h8.708c.797 0 1.439.774 1.439 1.726l.008 6.343z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.17 10.782a.576.576 0 000-1.15H9.03v-.415c.17-.069.327-.166.464-.288l2.014-1.726a.604.604 0 00.083-.809.512.512 0 00-.75-.09L8.826 8.032a.5.5 0 01-.662 0L6.151 6.305a.512.512 0 00-.751.09.61.61 0 00.083.81l2.014 1.727c.137.123.293.22.464.288v.411H5.823a.576.576 0 000 1.151H7.96v1.152H5.823a.576.576 0 000 1.15H7.96v.576a.535.535 0 001.07 0v-.575h2.138a.576.576 0 000-1.151H9.031v-1.152h2.138z"
  }))));
}

export default SvgFinancialManage;